export const GET_META_TAGS = "GET_META_TAGS"
export const GET_META_TAGS_SUCCESS = "GET_META_TAGS_SUCCESS"
export const GET_META_TAGS_FAILED = "GET_META_TAGS_FAILED"
export const RESET_META_TAGS = "RESET_META_TAGS"

export const CREATE_META_TAG = "CREATE_META_TAG"
export const CREATE_META_TAG_SUCCESS = "CREATE_META_TAG_SUCCESS"
export const CREATE_META_TAG_FAILED = "CREATE_META_TAG_FAILED"

export const OPEN_DELETE_TAG_MODAL = "OPEN_DELETE_TAG_MODAL"
export const HIDE_DELETE_TAG_MODAL = "HIDE_DELETE_TAG_MODAL"

export const DELETE_META_TAG = "DELETE_META_TAG"
export const DELETE_META_TAG_SUCCESS = "DELETE_META_TAG_SUCCESS"
export const DELETE_META_TAG_FAILED = "DELETE_META_TAG_FAILED"

export const UPDATE_META_TAG = "UPDATE_META_TAG"
export const UPDATE_META_TAG_SUCCESS = "UPDATE_META_TAG_SUCCESS"
export const UPDATE_META_TAG_FAILED = "UPDATE_META_TAG_FAILED"

export const OPEN_MERGE_TAGS_MODAL = "OPEN_MERGE_TAGS_MODAL"
export const HIDE_MERGE_TAGS_MODAL = "HIDE_MERGE_TAGS_MODAL"

export const MERGE_META_TAGS = "MERGE_META_TAGS"
export const MERGE_META_TAGS_SUCCESS = "MERGE_META_TAGS_SUCCESS"
export const MERGE_META_TAGS_FAILED = "MERGE_META_TAGS_FAILED"

export const GET_TAG = "GET_TAG"
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS"
export const GET_TAG_FAILED = "GET_TAG_FAILED"
export const RESET_TAG = "RESET_TAG"
